import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';

export default class NuiPromptDialog extends React.Component {

    state = {};

    handleCancel = () => {
        this.props.onClose('cancel');
    };

    handleOk = () => {
        this.props.onClose('ok');
    };

    handleChange = name => event => {
        this.props.parent.setState({
            [name]: event.target.value,
        });
    };

    render() {
        const { ...other } = this.props;

        return (
            <Dialog {...other}>
              <DialogTitle id="prompt-dialog-title">
                {this.props.title}
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {this.props.message}
                </DialogContentText>
                <TextField
                  value={this.props.parent.state.stateName}
                  onChange={this.handleChange(this.props.stateName)}
                  autoFocus
                  margin="normal"
                  id="name1"
                  label={this.props.label}
                  type={this.props.type}
                  fullWidth
                />
                {(this.props.stateName2 != null)
                ? <TextField
                    value={this.props.parent.state[this.props.stateName2]}
                    onChange={this.handleChange(this.props.stateName2)}
                    margin="normal"
                    id="name2"
                    label={this.props.label2}
                    type={this.props.type2}
                    fullWidth
                  />
                : ""}
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleCancel} color="inherit">
                  Cancel
                </Button>
                <Button onClick={this.handleOk} color="primary" autoFocus>
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
        );
    }
}
